<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>汽车保险系统</el-breadcrumb-item>
        <el-breadcrumb-item>汽车保险申请管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="申请情况：">
              <el-select size="small" v-model="listParams.status" placeholder="请选择审核状态" clearable>
                <el-option value="0" label="全部"></el-option>
                <el-option value="1" label="待反馈"></el-option>
                <el-option value="2" label="未投保"></el-option>
                <el-option value="3" label="已投保"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="保险类型：">
              <el-select size="small" v-model="listParams.type" placeholder="请选择审核状态" clearable>
                <el-option value="0" label="全部"></el-option>
                <el-option value="1" label="汽车保险"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="9">
            <el-form-item label="申请日期：">
              <el-date-picker
                clearable
                size="small"
                v-model="listParams.tempDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 300px; float: left; margin-top: 5px"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-button size="small" @click="searchData" style="margin-top: 4px"> 查询 </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="margin-bottom: 40px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table :data="tableData" max-height="800" border>
        <el-table-column prop="applyStatus" align="center" label="申请情况"> </el-table-column>

        <el-table-column prop="type" align="center" label="保险类型"> </el-table-column>

        <el-table-column prop="applyTime" align="center" label="申请日期">
          <template slot-scope="scope">
            <span>{{ scope.row.applyTime | formatDateByCN }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="id" align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="linkToDetailPage(scope.row.id)"> 查看详情 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      id: "",
      listParams: {
        status: "",
        type: "",
        tempDate: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    searchData() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 跳转至详情页
     * @param id
     */
    linkToDetailPage(id) {
      this.$router.push({
        name: "carInsuranceDetail",
        query: {
          id: id,
        },
      });
    },
    loadTableData() {
      this.tableLoading = true;
      let startDate, endDate;
      try {
        startDate = this.listParams.tempDate[0];
        // 选1号则 传1号24点的时间戳
        if (this.listParams.tempDate[1]) {
          endDate = this.listParams.tempDate[1] + 24 * 60 * 60 * 1000;
        }
      } catch (e) {
        startDate = "";
        endDate = "";
      }

      const bodyParams = Object.assign(
        {},
        {
          status: this.listParams.status,
          type: this.listParams.type,
          start: startDate,
          end: endDate,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        }
      );

      this.$http({
        url: global.apiUrl + "/carInsurance/apply/list",
        methods: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          } else {
            this.tableData = [];
            this.pager.total = 0;
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
  filters: {
    /**
     * 格式化为月份 2019年1月
     */
    formatDateByCN(val) {
      if (val) {
        var date = new Date(val);
        return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日";
      }
      return val;
    },
  },
};
</script>
<style></style>
